import { Component } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import Routes from 'ContentUtils/Routes';
import withGoToWebinarResources from 'ContentComponents/cmv2/decorators/withGoToWebinarResources';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.goToWebinar.${key}`;
function getWebinarTime(times) {
  if (times && times[times.length - 1]) {
    return I18n.moment(times[times.length - 1].startTime).format('LLL');
  }
  return '';
}
class GoToWebinarSelector extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  get options() {
    return Object.keys(this.props.webinars).map(webinarKey => {
      const webinar = this.props.webinars[webinarKey];
      return {
        value: webinarKey,
        text: `${webinar.subject} ${getWebinarTime(webinar.times)}`
      };
    });
  }
  onChange(evt) {
    if (this.props.onWebinarChange) {
      this.props.onWebinarChange(evt.target.value);
    }
  }
  renderHeader() {
    return /*#__PURE__*/_jsxs(View, {
      paddingBlockEnd: "200",
      as: "div",
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('header.label')
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: i18nKey('helpMessage.label'),
          options: {
            link: /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: Routes.goToWebinar(),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: i18nKey('helpMessage.link')
              })
            })
          }
        })
      })]
    });
  }
  renderPlaceholder() {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('placeholder.label')
    });
  }
  render() {
    const {
      isFormEligible,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [this.renderHeader(), /*#__PURE__*/_jsx(UITooltip, {
        disabled: isFormEligible,
        headingText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltip.head')
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('tooltip.body')
        }),
        children: /*#__PURE__*/_jsx(UISelect, {
          placeholder: this.renderPlaceholder(),
          options: this.options,
          value: this.props.webinarKey,
          onChange: this.onChange,
          clearable: true,
          disabled: !isFormEligible,
          buttonUse: this.props.useOnDark ? 'form-on-dark' : 'form',
          readOnly: readOnly
        })
      })]
    });
  }
}
export default withGoToWebinarResources(GoToWebinarSelector);